/*!
This is a modernized variant of grunticon which exports onloadCSS, grunticon and svgLoadedCallback.
the functions onloadcss and grunticon are taken out of their original functions to function in this current lexical scope.
The grunticon-lib src/dist scripts need all the parts in the same script file/tag
*/

var _mutation = (function () {

	function isNode(object) {
		// DOM, Level2
		if (typeof Node === 'function') {
			return object instanceof Node;
		}
		// Older browsers, check if it looks like a Node instance)
		return object &&
			typeof object === "object" &&
			object.nodeName &&
			object.nodeType >= 1 &&
			object.nodeType <= 12;
	}

	// http://dom.spec.whatwg.org/#mutation-method-macro
	return function mutation(nodes) {
		if (nodes.length === 1) {
			return isNode(nodes[0]) ? nodes[0] : document.createTextNode(nodes[0] + '');
		}

		var fragment = document.createDocumentFragment();
		for (var i = 0; i < nodes.length; i++) {
			fragment.appendChild(isNode(nodes[i]) ? nodes[i] : document.createTextNode(nodes[i] + ''));

		}
		return fragment;
	};
}());

Document.prototype.prepend = Element.prototype.prepend = function prepend() {
	this.insertBefore(_mutation(arguments), this.firstChild);
};


/*! onloadCSS. (onload callback for loadCSS) [c]2017 Filament Group, Inc. MIT License */
/* global navigator */
/* exported onloadCSS */
function onloadCSS( ss, callback ) {
	var called;
	function newcb(){
			if( !called && callback ){
				called = true;
				callback.call( ss );
			}
	}
	if( ss.addEventListener ){
		ss.addEventListener( "load", newcb );
	}
	if( ss.attachEvent ){
		ss.attachEvent( "onload", newcb );
	}

	// This code is for browsers that don’t support onload
	// No support for onload (it'll bind but never fire):
	//	* Android 4.3 (Samsung Galaxy S4, Browserstack)
	//	* Android 4.2 Browser (Samsung Galaxy SIII Mini GT-I8200L)
	//	* Android 2.3 (Pantech Burst P9070)

	// Weak inference targets Android < 4.4
 	if( "isApplicationInstalled" in navigator && "onloadcssdefined" in ss ) {
		ss.onloadcssdefined( newcb );
	}
}


/*! loadCSS. [c]2017 Filament Group, Inc. MIT License */
(function(w){
	"use strict";
	/* exported loadCSS */
	var loadCSS = function( href, before, media ){
		// Arguments explained:
		// `href` [REQUIRED] is the URL for your CSS file.
		// `before` [OPTIONAL] is the element the script should use as a reference for injecting our stylesheet <link> before
		// By default, loadCSS attempts to inject the link after the last stylesheet or script in the DOM. However, you might desire a more specific location in your document.
		// `media` [OPTIONAL] is the media type or query of the stylesheet. By default it will be 'all'
		var doc = w.document;
		var ss = doc.createElement( "link" );
		var ref;
		if( before ){
			ref = before;
		}
		else {
			var refs = ( doc.body || doc.getElementsByTagName( "head" )[ 0 ] ).childNodes;
			ref = refs[ refs.length - 1];
		}

		var sheets = doc.styleSheets;
		ss.rel = "stylesheet";
		ss.href = href;
		// temporarily set media to something inapplicable to ensure it'll fetch without blocking render
		ss.media = "only x";

		// wait until body is defined before injecting link. This ensures a non-blocking load in IE11.
		function ready( cb ){
			if( doc.body ){
				return cb();
			}
			setTimeout(function(){
				ready( cb );
			});
		}
		// Inject link
			// Note: the ternary preserves the existing behavior of "before" argument, but we could choose to change the argument to "after" in a later release and standardize on ref.nextSibling for all refs
			// Note: `insertBefore` is used instead of `appendChild`, for safety re: http://www.paulirish.com/2011/surefire-dom-element-insertion/
		ready( function(){
			ref.parentNode.insertBefore( ss, ( before ? ref : ref.nextSibling ) );
		});
		// A method (exposed on return object for external use) that mimics onload by polling document.styleSheets until it includes the new sheet.
		var onloadcssdefined = function( cb ){
			var resolvedHref = ss.href;
			var i = sheets.length;
			while( i-- ){
				if( sheets[ i ].href === resolvedHref ){
					return cb();
				}
			}
			setTimeout(function() {
				onloadcssdefined( cb );
			});
		};

		function loadCB(){
			if( ss.addEventListener ){
				ss.removeEventListener( "load", loadCB );
			}
			ss.media = media || "all";
		}

		// once loaded, set link's media back to `all` so that the stylesheet applies once it loads
		if( ss.addEventListener ){
			ss.addEventListener( "load", loadCB);
		}
		ss.onloadcssdefined = onloadcssdefined;
		onloadcssdefined( loadCB );
		return ss;
	};
	// commonjs
	// if( typeof exports !== "undefined" ){
		// exports.loadCSS = loadCSS;
	// }
	// else {
		// console.log('windowloadcss');
		w.loadCSS = loadCSS;
	// }
}( typeof global !== "undefined" ? global : this ));


/*global loadCSS:true*/
/*global onloadCSS:true*/

// (function(window){
	var grunticon = function( css, onload ){
		"use strict";
		// expects a css array with 3 items representing CSS paths to datasvg, datapng, urlpng
		if( !css || css.length !== 3 ){
			return;
		}

		var navigator = window.navigator;
		var document = window.document;
		var Image = window.Image;

		// Thanks Modernizr & Erik Dahlstrom
		var svg = !!document.createElementNS && !!document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect && !!document.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#Image", "1.1") && !(window.opera && navigator.userAgent.indexOf('Chrome') === -1) && navigator.userAgent.indexOf('Series40') === -1;

		var img = new Image();

		img.onerror = function(){
			grunticon.method = "png";
			grunticon.href = css[2];
			loadCSS( css[2] );
		};

		img.onload = function(){
			var data = img.width === 1 && img.height === 1,
				href = css[ data && svg ? 0 : data ? 1 : 2 ];

			if( data && svg ){
				grunticon.method = "svg";
			} else if( data ){
				grunticon.method = "datapng";
			} else {
				grunticon.method = "png";
			}

			grunticon.href = href;
			onloadCSS( loadCSS( href ), onload );
		};

		img.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
		document.documentElement.className += " grunticon";
	};
	grunticon.loadCSS = loadCSS;
	grunticon.onloadCSS = onloadCSS;
	window.grunticon = grunticon;
// }(this));

/*global grunticon:true*/
// (function(grunticon, window){
	"use strict";
	var document = window.document;
	var selectorPlaceholder = "grunticon:";

	var ready = function( fn ){
		// If DOM is already ready at exec time, depends on the browser.
		// From: https://github.com/mobify/mobifyjs/blob/526841be5509e28fc949038021799e4223479f8d/src/capture.js#L128
		if ( document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading") {
			fn();
		} else {
			var created = false;
			document.addEventListener( "readystatechange", function() {
				if (!created) {
					created = true;
					fn();
				}
			}, false);
		}
	};

	// get the SVG link
	var getCSS = function( href ){
		return window.document.querySelector( 'link[href$="'+ href +'"]' );
	};

	var icons;

	// this function can rip the svg markup from the css so we can embed it anywhere
	var getIcons = function(stylesheet, refresh){
		if( icons && !refresh ){
			return icons;
		}

		icons = {};

		// get grunticon stylesheet by its href
		var svgss,
			rules, cssText,
			iconClass, iconSVGEncoded, iconSVGRaw;

		svgss = stylesheet.sheet;

		if( !svgss ){ return icons; }

		rules = svgss.cssRules ? svgss.cssRules : svgss.rules;
		for( var i = 0; i < rules.length; i++ ){
			cssText = rules[ i ].cssText;
			iconClass = selectorPlaceholder + rules[ i ].selectorText;
			iconSVGEncoded = cssText.split( ");" )[ 0 ].match( /US\-ASCII\,([^"']+)/ );
			if( iconSVGEncoded && iconSVGEncoded[ 1 ] ){
				iconSVGRaw = decodeURIComponent( iconSVGEncoded[ 1 ] );
				icons[ iconClass ] = iconSVGRaw;

			}
		}
		return icons;
	};

	// embed an icon of a particular name ("icon-foo") in all elements with that icon class
	// and remove its background image
	var embedIcons = function(iconsOrElement, icons){
		var parentElem, selectedElems, filteredElems, embedAttr, selector;

		if( !icons ){
			icons = iconsOrElement;
			parentElem = document;
		} else {
			parentElem = iconsOrElement;
		}

		// attr to specify svg embedding
		embedAttr = "data-grunticon-embed";

		for( var iconName in icons ){
			selector = iconName.slice(selectorPlaceholder.length);

			try {
				// get ALL of the elements matching the selector
				selectedElems = parentElem.querySelectorAll( selector );
			} catch (er) {
				// continue further with embeds even though it failed for this icon
				continue;
			}


			filteredElems = [];

			// keep only those elements with the embed attribute
			for( var i = 0; i < selectedElems.length; i++ ){
				if( selectedElems[i].getAttribute( embedAttr ) !== null ){
					filteredElems.push(selectedElems[i]);
				}
			}

			// continue if there are no elements left after filtering
			if( !filteredElems.length ){ continue; }

			// for all the elements matching the selector with the embed attribute
			// take the svg markup and embed it into the selected elements
			for( i = 0; i < filteredElems.length; i++ ){
				// console.log('filtered element', i, 'is', filteredElems[]);
				// filteredElems[ i ].innerHTML = icons[ iconName ];
				var s = document.createElement('span');
				s.innerHTML = icons[iconName];
				// console.log('s.innerHTML', s.innerHTML);
				
				// filteredElems[i].prepend(s);
				// console.log('firstChild',  filteredElems[i].firstChild);
				filteredElems[i].insertBefore(s, filteredElems[i].firstChild);
				filteredElems[ i ].style.backgroundImage = "none";
				filteredElems[ i ].removeAttribute( embedAttr );
			}
		}

		return filteredElems;
	};

	var svgLoadedCallback = function(callbackOrElement, callback){
		if( grunticon.method !== "svg" ){
			return;
		}
		ready(function(){
			var icons = getIcons( getCSS( grunticon.href ) );

			// if a callback was passed we assume the first param was
			// an element otherwise we just embed the icons
			if( typeof callback === "function" ){
				embedIcons( callbackOrElement, icons );
				callback();
			} else {
				embedIcons( icons );
			}

			// if the first argument was a callback we call it after embedding the icons
			if ( typeof callbackOrElement === "function" ){
				callbackOrElement();
			}
		});
	};

	grunticon.embedIcons = embedIcons;
	grunticon.getCSS = getCSS;
	grunticon.getIcons = getIcons;
	grunticon.ready = ready;
	grunticon.svgLoadedCallback = svgLoadedCallback; //TODO DEPRECATED
	grunticon.embedSVG = svgLoadedCallback;

	// // http://www.grunticon.com/ see source
	// var svgLoadedCallback = function() {
	// 	grunticon.svgLoadedCallback();
	// 	if (typeof $ !== 'undefined') {
	// 		$(document).trigger('svg:embed:complete');
	// 	}
	// }

	export {
		// loadCSS,
		grunticon,
		svgLoadedCallback
	}